var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenerate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7495 19.6688L23.3863 27.8864C23.7704 28.1936 24.308 28.1936 24.6535 27.8864L35.2903 19.6688C35.8279 19.2464 35.8279 18.4399 35.2903 18.0177L24.6535 9.83785C24.2694 9.53061 23.7318 9.53061 23.3863 9.83785L12.7495 18.017C12.1733 18.4395 12.1733 19.2842 12.7495 19.6684V19.6688Z",
    fill: "#BEBEBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2516 23.3554L33.485 22.0112L25.1138 28.5009C24.8066 28.7313 24.3842 28.885 24.0004 28.885C23.6163 28.885 23.1939 28.7315 22.8869 28.5009L14.4773 22.0112L12.7108 23.3554C12.1732 23.7778 12.1732 24.5843 12.7108 25.0064L23.3476 33.224C23.7317 33.5313 24.2693 33.5313 24.6148 33.224L35.2516 25.0064C35.8275 24.6226 35.8275 23.7778 35.2513 23.3554H35.2516Z",
    fill: "#BEBEBE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2516 28.7313L33.485 27.3872L25.1138 33.8385C24.8066 34.0689 24.3842 34.2226 24.0004 34.2226C23.6163 34.2226 23.1939 34.1074 22.8869 33.8385L14.4773 27.3491L12.7108 28.6933C12.1732 29.1157 12.1732 29.9222 12.7108 30.3443L23.3476 38.5619C23.7317 38.8692 24.2693 38.8692 24.6148 38.5619L35.2516 30.3443C35.8275 29.9602 35.8275 29.1537 35.2513 28.7313H35.2516Z",
    fill: "#BEBEBE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerate);
export default __webpack_public_path__ + "static/media/Generate.933cf47ba0e9173ecec7a03a5b4a9341.svg";
export { ForwardRef as ReactComponent };